/**
 * 日语（ja）
 */

import jaLocale from 'element-ui/lib/locale/lang/ja'

export default {
  ...jaLocale,
  common: {},
  // 语言
  lang: {
    english: '英語',
    spanish: 'スペイン語',
    japanese: '日本語',
    portuguese: 'ポルトガル語',
    french: 'フランス語',
    russian: 'ロシア語',
    arabic: 'アラビア語',
    german: 'ドイツ語',
    italian: 'イタリア語',
    vietnam: 'ベトナム',
    turkey: 'トルコ',
    korean: '韓国語',
    thai: 'タイ語',
    dutch: 'オランダ語',
    hebrew: 'ヘブライ語',
    indonesian: 'インドネシア語'
  },

  // 苏子龙
  // 现货页面 inSrock
  inSrock: {
    category: 'カテゴリー',
    search: '探す',
    searchingFor: '複数の検索をコンマまたはスペースで分離する',
    shippingFrom: '発送元',
    fabric: 'ファブリック',
    price: '価格',
    inventory: '在庫',
    newest: '最新',
    sales: '販売'
  }

  // 张丰

  // 孙泽严
}
